import logo1 from "../../media/residential/1.png";
import logo2 from "../../media/residential/2.png";
import logo3 from "../../media/residential/3.png";
import logo4 from "../../media/residential/4.png";
import logo5 from "../../media/residential/5.png";
import logo6 from "../../media/logo/vanica.png";
import logo7 from "../../media/logo/viola.png";
import logo8 from "../../media/residential/6.png";

const images = [logo8, logo1, logo6, logo2, logo3, logo4, logo5, logo7];

export default images;
